import React, { useRef, useState, useEffect } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

const Sponsors = () => {
  const scrollRef = useRef(null);
  const [showLeftArrow, setShowLeftArrow] = useState(false);
  const [showRightArrow, setShowRightArrow] = useState(false);

  const sponsors = [
    {
      name: "Prime Bank",
      logo: "https://res.cloudinary.com/dxdvcplbl/image/upload/v1755158356/WhatsApp_Image_2025-08-14_at_1.52.16_PM_vcnxpd.jpg",
    },
    {
      name: "Vorosha Group",
      logo: "https://res.cloudinary.com/dxdvcplbl/image/upload/v1755158355/varosha_hfzsug.jpg",
    },
    {
      name: "RFL Group",
      logo: "https://res.cloudinary.com/dxdvcplbl/image/upload/v1755158355/RFL_Group_vvw55h.jpg",
    },
    {
      name: "Steadfast Courier Limited",
      logo: "https://res.cloudinary.com/dxdvcplbl/image/upload/v1755158355/WhatsApp_Image_2025-08-14_at_1.51.39_PM_xknlye.jpg",
    },
  ];

  const checkScrollPosition = () => {
    if (scrollRef.current) {
      const { scrollLeft, scrollWidth, clientWidth } = scrollRef.current;
      setShowLeftArrow(scrollLeft > 0);
      setShowRightArrow(scrollLeft < scrollWidth - clientWidth - 1);
    }
  };

  const scroll = (direction) => {
    if (scrollRef.current) {
      const scrollAmount = 300;
      scrollRef.current.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    }
  };

  useEffect(() => {
    const currentRef = scrollRef.current;
    currentRef?.addEventListener("scroll", checkScrollPosition);
    window.addEventListener("resize", checkScrollPosition);
    checkScrollPosition(); // Initial check

    return () => {
      currentRef?.removeEventListener("scroll", checkScrollPosition);
      window.removeEventListener("resize", checkScrollPosition);
    };
  }, []);

  return (
    <section className="py-16 px-4 md:px-20 bg-gray-50 relative">
      <div className="max-w-7xl mx-auto relative">
        <h2 className="text-3xl font-bold text-center mb-12 uppercase">
          Our Valued Sponsors
        </h2>

        <div className="relative">
          {/* Left Arrow - only shows when needed */}
          {showLeftArrow && (
            <button
              onClick={() => scroll("left")}
              className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-4 bg-white shadow-lg rounded-full p-2 z-10 hover:bg-gray-100"
              aria-label="Scroll left"
            >
              <ChevronLeft size={24} />
            </button>
          )}

          {/* Scrollable Sponsor Cards */}
          <div
            ref={scrollRef}
            className="flex lg:items-center lg:justify-center overflow-x-auto gap-8 pb-4 scrollbar-hide scroll-smooth px-2"
            style={{ scrollBehavior: "smooth" }}
          >
            {sponsors.map((sponsor, index) => (
              <div
                key={index}
                className="flex-shrink-0 w-48 bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300"
              >
                <div className="h-32 flex items-center justify-center p-4">
                  <img
                    src={sponsor.logo}
                    alt={sponsor.name}
                    className="max-h-full max-w-full object-contain"
                  />
                </div>
                <div className="p-4 border-t border-gray-100">
                  <p className="text-center font-medium text-sm">
                    {sponsor.name}
                  </p>
                </div>
              </div>
            ))}
          </div>

          {/* Right Arrow - only shows when needed */}
          {showRightArrow && (
            <button
              onClick={() => scroll("right")}
              className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-4 bg-white shadow-lg rounded-full p-2 z-10 hover:bg-gray-100"
              aria-label="Scroll right"
            >
              <ChevronRight size={24} />
            </button>
          )}
        </div>
      </div>
    </section>
  );
};

export default Sponsors;
